module.exports = __webpack_public_path__ + "img/default_logo1.827c4bb4.png";